<ng-container *ngIf="!newTransfer">
	<div [ngSwitch]="beneficiaryType">
		<div *ngSwitchCase="BILL_PAYMENT_TYPE">
			<div *ngIf="moniepointBeneficiaries?.length" class="m-t-24">
				<div>
					<div class="bill-payment-divider"></div>
				</div>
				
			</div>
		</div>
		<div *ngSwitchCase="TRANSFER_TYPE">
			<div *ngIf="moniepointBeneficiaries?.length" class="m-t-24">
			
				<!-- <div>
					<div nz-row nzAlign="middle" nzJustify="space-between">
						<div class="line"></div>
						<div class="or-text">OR</div>
						<div class="line"></div>
					</div>
				</div> -->
				<div nz-row nzAlign="middle" nzJustify="space-between">
					<div class="select-from-save">Select Beneficiaries</div>
					<div (click)="openMore()" *ngIf="totalMoniepointBeneficiaries.length > 4" class="see-all addCursor">
						See All
					</div>
				</div>
			</div>
		</div>
		<div *ngSwitchCase="AIRTIME_TYPE">
			<!-- <div class="m-t-24">
				<div nz-row nzAlign="middle" nzJustify="space-between">
					<div class="line"></div>
					<div class="or-text">Or</div>
					<div class="line"></div>
				</div>
			</div> -->
			<div class="m-t-24">
				<div class="send-to-beneficiary">
					Send to a frequent beneficiary
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="moniepointBeneficiaries.length" class="m-t-4">
		<div (click)="selectBeneficiary(beneficiary)"
			*ngFor="let beneficiary of moniepointBeneficiaries|searchFilter:searchParams:'beneficiaryName';let k = index"
			class="addCursor m-t-16 {{getBeneficiaryContainerColor(beneficiary?.classIndex)}}">
			<div class="beneficiary-row-bill-payment">
				<div class="flex items-center flex-nowrap">
					<div class="beneficiary-box {{getBeneficiaryBoxColor(beneficiary?.classIndex)}}">
						{{getInitials(beneficiary?.beneficiaryName)}}
					</div>
					<div class="ml-[16px]">
						<div class="beneficiary-name">
							{{beneficiary?.beneficiaryName}}
						</div>
						<div class="beneficiary-value m-t-4">
							{{beneficiary?.customerIdName}}: {{beneficiary?.customerIdValue}}
						</div>
					</div>
				</div>
				<div>
					<!-- <app-icon icon="caret-right"></app-icon> -->
				</div>
			</div>

			<div *ngIf="((moniepointBeneficiaries?.length - 1) !== k) && !beneficiary?.classIndex">
				<div class="bill-payment-divider"></div>
			</div>

		</div>
	</div>

	<div *ngIf="totalMoniepointBeneficiaries.length > 4 && beneficiaryType === AIRTIME_TYPE || beneficiaryType === BILL_PAYMENT_TYPE" class="m-t-62">
		<div (click)="openMore()" class="view-all-beneficiary addCursor">
			View all Beneficiaries
		</div>
	</div>
</ng-container>

<ng-container *ngIf="newTransfer">
	<ng-container *ngIf="moniepointBeneficiaries.length > 0; else emptyState">
		<h4 class="beneficiary-title-mobile">Select Beneficiaries</h4>
		<div (click)="selectBeneficiary(beneficiary)"
			*ngFor="let beneficiary of moniepointBeneficiaries|searchFilter:searchParams:'beneficiaryName';let k = index"
			class="addCursor m-t-16 {{getBeneficiaryContainerColor(beneficiary?.classIndex)}}">
			<div class="beneficiary-row-bill-payment" style="padding: 0;" nz-row nzAlign="middle"
				nzJustify="space-between">
				<div nz-row nzAlign="middle">
					<div class="beneficiary-box color_I_box">
						{{getInitials(beneficiary?.beneficiaryName)}}
					</div>
					<div class="m-l-20">
						<div class="beneficiary-name-mobile">
							{{beneficiary?.beneficiaryName}}
						</div>
						<div class="beneficiary-value-mobile m-t-4">
							{{beneficiary?.customerIdName}} - {{beneficiary?.customerIdValue}}
						</div>
					</div>
				</div>
				<div>
					<svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd"
							d="M1.15573 0.454505C1.61338 0.015165 2.35537 0.015165 2.81302 0.454505L9.84427 7.2045C10.3019 7.64384 10.3019 8.35616 9.84427 8.7955L2.81302 15.5455C2.35537 15.9848 1.61338 15.9848 1.15573 15.5455C0.698089 15.1062 0.698089 14.3938 1.15573 13.9545L7.35834 8L1.15573 2.0455C0.698089 1.60616 0.698089 0.893845 1.15573 0.454505Z"
							fill="#B4CBD5" />
					</svg>
				</div>
			</div>
			<div *ngIf="((moniepointBeneficiaries?.length - 1) !== k) && !beneficiary?.classIndex">
				<div class="bill-payment-divider"></div>
			</div>
		</div>
		<div *ngIf="moniepointBeneficiaries?.length && beneficiaryType == TRANSFER_TYPE"
			class="m-t-24 flex justify-center">
			<div class="m-t-24" nz-row nzAlign="middle" nzJustify="space-between">
				<div (click)="openMore()" class="see-all addCursor">
					View/Manage All Beneficiaries
				</div>
			</div>
		</div>

	</ng-container>
</ng-container>

<ng-template #emptyState>
	<div class="flex-center">
		<img alt="" src="assets/images/svgs/empty-beneficiaries-full.svg">
	</div>
	<div class="m-t-16">
		<div class="empty-beneficiary-text">
			No saved beneficiary...yet
		</div>
	</div>
</ng-template>